import { QuestionMarkCircleIcon } from '@heroicons/react/24/outline'
import cloneDeep from 'clone-deep'
import { LayoutLoading } from 'components/LayoutLoading'
import { integrationTypeTitles } from 'pages/Loan/OrderAppraisals/types'
import { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { getCredentials, getCredentialTypes } from 'services'
import { svgSearch } from 'stories/assets'
import {
  Input,
  Pagination,
  PlainTable,
  Select,
  Tooltip,
} from 'stories/components'
import { formatTime } from 'utils'

const itemCountPerPage = 10

export const Credentials = () => {
  const [isLoading, setIsLoading] = useState(false)
  const [total, setTotal] = useState(0)
  const [integrationTypes, setIntegrationTypes] = useState<Record<string, string>>({})
  const [data, setData] = useState<Array<Array<any>>>([])
  const [filters, setFilters] = useState<Record<string, any>>({
    query: '',
    pageNum: 0,
    type: '',
  })
  const [filterQuery, setFilterQuery] = useState(filters.query)

  const header: any = [
    'No',
    '<span><div className="border-b border-solid border-[1px] w-fit mb-1 border-gray-500">Name</div>Email</span>',
    '<span><div className="border-b border-solid border-[1px] w-fit mb-1 border-gray-500">Credential Type</div>Credential Username</span>',
    'Updated at',
    'Status',
  ]
  const initData = async () => {
    setIsLoading(true)
    const res = await getCredentials({
      query: filterQuery,
      count: itemCountPerPage,
      skip: 0 * itemCountPerPage,
      type: filters.type,
    })
    setTotal(res.totalCounts)
    setData(res.credentials)
    setIsLoading(false)
  }
  useEffect(() => {
    initData()
  }, [filterQuery])

  useEffect(() => {
    ;(async () => {
      const types: string[] = await getCredentialTypes()
      const labels: Record<string, string> = {}
      types.forEach((type) => (labels[type] = (integrationTypeTitles as any)[type] || type))
      setIntegrationTypes(labels)
    })()
  }, [])

  const onPageNavigate = (num: number) => {
    onChangeFilter('pageNum', num)
  }

  const onChangeFilter = (key: string, value: any) => {
    const newFilters = cloneDeep(filters)
    newFilters[key] = value
    setFilters(newFilters)
    if (key === 'query') setFilterQuery(value)
    else filterUsersData(newFilters)
  }

  const filterUsersData = async (filters: Record<string, any>) => {
    setIsLoading(true)
    const { credentials, totalCounts } = await getCredentials({
      query: filters.query.trim(),
      count: itemCountPerPage,
      skip: filters.pageNum * itemCountPerPage,
      type: filters.type,
    })
    setData(credentials)
    setTotal(totalCounts)
    setIsLoading(false)
  }

  return (
    <div>
      <h1 className="text-2xl font-bold flex items-center pb-5">AMC Credentials</h1>
      <LayoutLoading show={isLoading} />
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 mb-2 items-center">
        <Input
          type="search"
          title="Search Users"
          hasIcon
          icon={svgSearch}
          value={filters.query}
          onChange={(value) => onChangeFilter('query', value)}
        />
        <Select
          id="search-type"
          title="Type"
          options={integrationTypes}
          value={filters.type}
          hasDefaultOption
          onChange={(value) => onChangeFilter('type', value)}
        />
      </div>
      <PlainTable
        header={header}
        data={data.map((item: any, index: number) => [
          index + 1,
          <div>
            <div>
              <Link
                to={`/registrations/${item.userId}`}
                target="_blank"
                className="font-bold text-shade-blue cursor-pointer border-b w-fit mb-2 text-left"
              >
                {item.name}
              </Link>
            </div>
            {item.email}
          </div>,
          <div>
            <div>
              <span className="border-b">{integrationTypes[item.type]}</span>
            </div>
            {item.userName}
          </div>,
          formatTime(item.updatedAt),
          !item.error ? (
            'Enabled'
          ) : (
            <p className="flex items-center gap-2">
              Inactive
              <Tooltip message={item.error}>
                <span>
                  <QuestionMarkCircleIcon className="w-4 h-4" />
                </span>
              </Tooltip>
            </p>
          ),
        ])}
        tdClass="px-6 py-4"
      />
      <div className="flex justify-end items-center mt-3 mb-3">
        <Pagination
          totalCount={total}
          itemCountPerPage={itemCountPerPage}
          onNavigate={onPageNavigate}
          pageNum={filters.pageNum}
        />
      </div>
    </div>
  )
}
